import {SubscriberMelody} from "./subscriber-melody";

export class Rule {
  ruleId: number;
  melodyIdFromPlatform: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  startTime: string;
  endTime: string;

  melody: SubscriberMelody;
  enabled: boolean;
  shown: boolean;
}
